import DashboardRoute from "./dashboard/Dashboard.Route";
import MasterRoute from './master/MasterRoute';
import SettingsRoute from './settings/SettingsRoute';
import UsersRoute from './users/UsersRoute';
import ProjectRoute from "./project/ProjectRoute";
import FarmRoute from "./farm/FarmRoute";
import MarketplaceRoute from "./marketplace/MarketplaceRoute";
import ReportRoute from "./report/ReportRoute";
import GrnRoute from "./grn/GrnRoute";
import UserGuideRoute from "./user_guide/UserGuideRoute";
import CropManagementRoute from "./crop_management/CropManagementRoute";
import ConstructionManagementRoute from "./construction_management/ConstructionManagementRoute";
import AppVersionRoute from "./app_version/AppVersionRoute";

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...MasterRoute(),
        ...SettingsRoute(),
        ...UsersRoute(),
        ...ProjectRoute(),
        ...FarmRoute(),
        ...MarketplaceRoute(),
        ...ReportRoute(),
        ...GrnRoute(),
        ...UserGuideRoute(),
        ...CropManagementRoute(),
        ...ConstructionManagementRoute(),
        ...AppVersionRoute(),
    ]
}

export default PrivateRoute;